import React from 'react';
import FeatureFlagPlaceholder from 'components/ui/FeatureFlagPlaceholder';

export default function TokenAdmin() {
  return (
    <FeatureFlagPlaceholder
      title="Token Administration"
      description="Token minting, burning, registry management, and issuance controls will be available in Phase 2 for platform administrators."
      phase="Phase 2"
    />
  );
}
